import { render, staticRenderFns } from "./BtnInserirAplicacao.vue?vue&type=template&id=3ba65bd7&"
import script from "./BtnInserirAplicacao.vue?vue&type=script&lang=js&"
export * from "./BtnInserirAplicacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports